<template>
    <!-- display buttons for add to cart here -->
    <button @click.prevent="addItemToCartFxn(item)">
        <i class="fas fa-cart-plus"></i> {{atcBtnText}}
    </button>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    name: 'AddToCart',
    props: {
        item: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            itemSavedStatus: false,
            atcBtnText: 'Add to Cart'
        }
    },
    methods: {
        ...mapActions(['cartItemsCountAction']),
        addItemToCartFxn(theItemDetails) {
            if(!theItemDetails) return

            // prepare the carts item obj
            let theItemObj = {
                userId: 'ani_guest_shopper',
                itemId: theItemDetails._id,
                itemQty: 1, // starts with one, shoppers can adjust qty on checkout page
                itemPrice: theItemDetails.onSale ? theItemDetails.onSalePrice : theItemDetails.price,
            }

            // add the userId only when shopper is logged in
            if(this.loggedInUser){ theItemObj.userId = `${this.loggedInUser._id}` }
            
            // calculate to obtain the item sum price
            theItemObj.itemSumPrice = parseInt(theItemObj.itemQty * theItemObj.itemPrice)

            // default notification message via button for user
            this.atcBtnText = 'Item Added!'

            // required array to hold cart items
            let localStorageATCItemIds = []
            
            // check if user already have a add-to-cart items storage on local-storage
            localStorageATCItemIds = JSON.parse(localStorage.getItem('ani_items_atc')) 
            if(localStorageATCItemIds && localStorageATCItemIds.length) {
                // update item quantity and sum-price if the item already exists in shoppers cart
                let existingCartItemIndex = localStorageATCItemIds.findIndex(cartItem => cartItem.itemId === theItemObj.itemId)
                if(existingCartItemIndex !== -1){
                    let existingCartItemObj = localStorageATCItemIds[existingCartItemIndex]
                    existingCartItemObj.itemQty += 1
                    existingCartItemObj.itemSumPrice = parseInt(existingCartItemObj.itemQty * existingCartItemObj.itemPrice)
                    localStorageATCItemIds.splice(existingCartItemIndex, 1, existingCartItemObj)

                    // default notification message via button for user
                    this.atcBtnText = 'Qty Updated!'
                } 
                // add new item-obj into existing local-storage cart array
                else {
                    localStorageATCItemIds.push(theItemObj)
                }
                localStorage.setItem('ani_items_atc', JSON.stringify(localStorageATCItemIds))
            } 
            // create a new add-to-cart storage on local-storage
            else {
                localStorageATCItemIds = [theItemObj]
                localStorage.setItem('ani_items_atc', JSON.stringify(localStorageATCItemIds))
            }

            // update cart items counter via vuex action
            this.cartItemsCountAction().then(() => {}).catch((e) => {})

            // replace the original button name after showing notification for 2 secs
            setTimeout(() => {
                this.atcBtnText = 'Add to Cart'
            }, 2000);
        },
    },
    computed: {
        ...mapGetters(['authenticated', 'user']),
        loggedInUser() {
            if(this.authenticated && this.user){
                return this.user
            }
            return false
        }
    },
}
</script>
